import React, { useState } from 'react';
import './Project.css';
import SB from '../../assets/SB.png';
import PZ from '../../assets/PZ.png';
import AS from '../../assets/aSolution.png';
import LX from '../../assets/LUXE.png';
import DV from '../../assets/divine.png';
import TB from '../../assets/TB.png';

function Project() {
    const [expandedIndex, setExpandedIndex] = useState(null);

    const projectData = [
        {
            title: 'Train Brain',
            description: 'Train Brain is a small side project I built in my free time using TypeScript and Next.js. It’s a simple browser game with a bunch of quick challenges designed to test things like memory, focus, and reaction speed. I mainly made it to experiment with game logic, UI interactions, and to just build something fun and interactive.',
            imageUrl: TB,
            projectUrl: 'http://utsab-crompoide.github.io/train-brain/',
            featured: false
        },
        {
            title: 'SawariBooking',
            description: 'Developed the Sawari Booking mobile app using React Native and Expo. The app connects travelers in Nepal with vehicle owners, offering rentals for cars, SUVs, and other vehicles. Built all core user-facing features, authentication, and booking flows while integrating APIs with a PHP Laravel backend.',
            imageUrl: SB,
            projectUrl: 'http://sawaribooking.com',
            featured: false
        },
        {
            title: 'Playerz',
            description: 'Built a React Native (Expo) social-style mobile application for U.S. college basketball players with various access roles. Integrated AWS services extensively including Cognito (Auth), S3 (Media), Lambda (Serverless logic), and Amplify to ensure a secure and scalable backend-to-frontend connection.',
            imageUrl: PZ,
            projectUrl: 'http://playerzapp.com',
            featured: false
        },
        {
            title: 'IENSURE',
            description: 'Worked on a .NET-based SaaS platform for insurance companies to automate routines. Handled customer info, claims processing, and reports. Developed strict and reliable APIs for core functionality.',
            imageUrl: AS,
            projectUrl: 'http://project-link.com',
            featured: false
        },
        {
            title: 'Luxe Little Baby Wear',
            description: 'Helped set up a WordPress e-commerce storefront, prioritizing theme customization, plugin integration, and checkout flow improvements.',
            imageUrl: LX,
            projectUrl: 'https://luxelittlebabywear.com.au/',
            featured: false
        },
        {
            title: 'Divine Collection',
            description: 'Configured product listings and optimized the shopping experience for a WordPress clothing store, handling general site maintenance.',
            imageUrl: DV,
            projectUrl: 'https://divinecollection.com.au/',
            featured: false
        }
    ];

    const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <div className='project'>
            <div className='header'>
                <h1 className="section-title">Selected Works</h1>
            </div>
            <div className='bento-grid'>
                {projectData.map((project, index) => (
                    <div
                        key={index}
                        className={`bento-item ${project.featured ? 'featured' : ''} ${expandedIndex === index ? 'expanded' : 'collapsed'}`}
                    >
                        <div className='bento-image-container'>
                            <img
                                className="bento-image"
                                src={project.imageUrl}
                                alt={project.title}
                                style={project.title === 'IENSURE' ? { filter: 'drop-shadow(0 0 20px rgba(255,255,255,0.2))' } : {}}
                            />
                            <div className="bento-overlay"></div>
                        </div>

                        <div className='bento-content'>
                            <h2>{project.title}</h2>
                            <div className="bento-desc-wrapper">
                                <p>{project.description}</p>
                            </div>

                            <div className="bento-footer">
                                <button
                                    className='seeMoreBtn'
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleExpand(index);
                                    }}
                                >
                                    {expandedIndex === index ? 'Collapse' : 'Read More'}
                                </button>

                                {project.projectUrl && project.projectUrl !== 'http://project-link.com' && (
                                    <a
                                        href={project.projectUrl}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="bento-link"
                                    >
                                        Visit Live ↗
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Project;